<template>
  <div class="modal-mask">
    <div class="Login">
      <div class="close">
        <img
          @click="$emit('closeLogin')"
          src="../../assets/Icons/close.svg"
          alt="close"
        />
      </div>
      <forgot-password
        v-if="this.page === 'forgotPass'"
        @newPassword="newPass"
        :username="username"
        @close="closeLogin"
      />
      <login
        v-if="this.page === 'login'"
        :username="username"
        :password="password"
        :errorMessage="errorMessage"
        @goToForgotPassword="goToForgotPassword"
        @goTo2Factor="goTo2Factor"
        @goToRegister="goToRegister"
        @close="closeLogin"
      />
      <two-step
        v-if="this.page === '2factor'"
        :number="number"
        @login="loginUser"
        @resendCode="resendCode"
        @close="closeLogin"
      />
      <register
        v-if="this.page === 'register'"
        :regname="regname"
        :regmail="regmail"
        :regcompany="regcompany"
        :regphone="regphone"
        :regpass="regpass"
        :regpassconfirm="regpassconfirm"
        @goToLogin="goToLogin"
        @close="closeLogin"
      />
    </div>
  </div>
</template>

<script>
// import Login from "@/components/LoginFlow/Login.vue";
// import TwoStep from "@/components/LoginFlow/TwoStep.vue";
// import Register from "@/components/LoginFlow/Register.vue";
// import ForgotPassword from "@/components/LoginFlow/ForgotPassword.vue";
// // import { setTimeout } from 'timers'
// import { mapActions, mapMutations, mapState } from "vuex";
// export default {
//   name: "LoginForm",
//   components: {
//     Login,
//     TwoStep,
//     Register,
//     ForgotPassword,
//   },
//   props: {
//     error: {
//       type: Boolean,
//       default: false,
//     },
//   },
//   data() {
//     return {
//       isLoading: false,
//       errorMessage: "",
//       regname: "",
//       regmail: "",
//       regcompany: "",
//       regphone: "",
//       regpass: "",
//       regpassconfirm: "",
//       username: "",
//       password: "",
//       number: "",
//     };
//   },
//   watch: {
//     $route: function (params) {
//       if (params.query.error === "500") {
//         this.error = true;
//         this.errorMessage = "Het opgegeven emailadres/wachtwoord is incorrect";
//         this.isLoading = true;
//       }
//     },
//   },
//   methods: {
//     goToForgotPassword() {
//       this.setPageRoute("forgotPass");
//     },
//     goToRegister() {
//       this.setPageRoute("register");
//     },
//     goToLogin(user) {
//       this.regname = user.regname;
//       this.regmail = user.regmail;
//       this.regcompany = user.regcompany;
//       this.regphone = user.regphone;
//       this.regpass = user.regpass;
//       this.regpassconfirm = user.regpassconfirm;
//       this.register(user);
//       this.setPageRoute("login");
//     },
//     goTo2Factor(user) {
//       this.username = user.username;
//       this.password = user.password;
//       this.twoStep(user);
//       this.setPageRoute("2factor");
//     },
//     newPass(user) {
//       this.username = user.username;
//       this.forgotPassword(user);
//     },
//     loginUser(number) {
//       const user = {
//         username: this.username,
//         password: this.password,
//         number: number,
//       };
//       this.login(user);
//       setTimeout(() => window.location.replace("/dashboard"), 1000);
//     },
//     resendCode() {
//       const user = { username: this.username, password: this.password };
//       this.twoStep(user);
//     },
//     setErrorFalse() {
//       this.error = false;
//     },
//     ...mapActions("auth", ["register", "twoStep", "login", "forgotPassword"]),
//     ...mapMutations("auth", ["closeLogin", "setPageRoute"]),
//   },
//   computed: {
//     ...mapState("auth", ["page"]),
//   },
// };

import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Login from "@/components/LoginFlow/Login.vue";
import TwoStep from "@/components/LoginFlow/TwoStep.vue";
import Register from "@/components/LoginFlow/Register.vue";
import ForgotPassword from "@/components/LoginFlow/ForgotPassword.vue";

export default {
  name: "LoginForm",
  components: {
    Login,
    TwoStep,
    Register,
    ForgotPassword,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    // Define reactive data
    const isLoading = ref(false);
    const errorMessage = ref("");
    const regname = ref("");
    const regmail = ref("");
    const regcompany = ref("");
    const regphone = ref("");
    const regpass = ref("");
    const regpassconfirm = ref("");
    const username = ref("");
    const password = ref("");
    const number = ref("");

    // Watch for changes in the route query
    watch(
      () => route.query,
      (params) => {
        if (params.error === "500") {
          props.error = true;
          errorMessage.value =
            "Het opgegeven emailadres/wachtwoord is incorrect";
          isLoading.value = true;
        }
      }
    );

    // Define methods
    const goToForgotPassword = () => {
      store.commit("auth/setPageRoute", "forgotPass");
    };

    const goToRegister = () => {
      store.commit("auth/setPageRoute", "register");
    };

    const goToLogin = (user) => {
      regname.value = user.regname;
      regmail.value = user.regmail;
      regcompany.value = user.regcompany;
      regphone.value = user.regphone;
      regpass.value = user.regpass;
      regpassconfirm.value = user.regpassconfirm;
      store.dispatch("auth/register", user);
      store.commit("auth/setPageRoute", "login");
    };

    const goTo2Factor = (user) => {
      username.value = user.username;
      password.value = user.password;
      store.dispatch("auth/twoStep", user);
      store.commit("auth/setPageRoute", "2factor");
    };

    const newPass = (user) => {
      username.value = user.username;
      store.dispatch("auth/forgotPassword", user);
    };

    const loginUser = (num) => {
      const user = {
        username: username.value,
        password: password.value,
        number: num,
      };
      store.dispatch("auth/login", user);
      setTimeout(() => window.location.replace("/dashboard"), 1000);
    };

    const resendCode = () => {
      const user = {
        username: username.value,
        password: password.value,
      };
      store.dispatch("auth/twoStep", user);
    };

    const setErrorFalse = () => {
      props.error = false;
    };

    // Define computed property
    const page = computed(() => store.state.auth.page);

    const closeLogin = () => {
      store.commit("auth/closeLogin");
    };

    // Return reactive data, methods, and computed property
    return {
      isLoading,
      errorMessage,
      regname,
      regmail,
      regcompany,
      regphone,
      regpass,
      regpassconfirm,
      username,
      password,
      number,
      goToForgotPassword,
      goToRegister,
      goToLogin,
      goTo2Factor,
      newPass,
      loginUser,
      resendCode,
      setErrorFalse,
      page,
      closeLogin,
    };
  },
};
</script>

<style lang="sass" scoped>
.modal-mask
  position: fixed
  z-index: 9999
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .3)
.Login
  font-size: 15px
  display: flex
  flex-direction: column
  margin: 5px auto
  position: absolute
  color: $black
  top: 25px
  left: 0
  right: 0
  bottom: 0
  background-color: $white
  z-index: 9999
  padding: 15px 35px
  width: 70%
  height: 475px
  border-radius: 10px
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.5)
  .close
    position: absolute
    right: 0
    top: 0
    &:hover
      cursor: pointer

@media only screen and (min-width: 576px)
  .Login
    top: 80px
    padding: 35px 50px
    width: 50%

@media only screen and (min-width: 768px)
  .Login
    width: 420px
    .loginform
      .btn
        font-size: 15px
</style>
